3<template>
  <component :is="renderedIcon" v-if="renderedIcon" />
</template>

<script lang="ts" setup>
import { onMounted, shallowRef } from "vue";

const props = defineProps({
  icon: {
    required: true,
    type: String,
  },
});

type IconComponent = {
  __file: string;
  __hmrId: string;
  [key: string]: any;
};

type IconModule = {
  [Symbol.toStringTag]: "Module";
  default: IconComponent;
};
const renderedIcon = shallowRef<IconComponent | null>(null);

onMounted(() => {
  loadIcon();
});

async function loadIcon() {
  const module: IconModule = await import(`../../icons/${props.icon}.vue`);

  if (!module.default) {
    throw Error(`Icon ${props.icon} not found`);
  }

  renderedIcon.value = module.default;
}
</script>
